'use client';

import { Button } from '../ui/button';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

import { GoArrowDown } from 'react-icons/go';

export function ArrowDown() {
  const { t } = useTranslations();

  const scrollDown = () => {
    window.scrollTo({
      top: 820,
      behavior: 'smooth',
    });
  };

  return (
    <div onClick={scrollDown} className="flex cursor-pointer items-center justify-center gap-4">
      <Button size={'icon'} variant={'alternative-alt'} aria-label={t('text2313')}>
        <GoArrowDown size={20} aria-hidden="true" />
      </Button>
      <p className="whitespace-nowrap text-sm font-normal tracking-tight text-white lg:text-base">
        {t('text2313')}
      </p>
    </div>
  );
}
